import IService from '../IService';

export default IService.extend({
  scrape: function (programmerId, url) {
    const promise = $.Deferred();

    $.ajax({
      url: app.apiUrl('/api/v1/scrape'),
      type: 'GET',
      data: {
        programmerId: programmerId,
        url: url,
      },

      error: function () {
        promise.reject();
      },

      dataType: 'json',
      success: function (response) {
        if (!_.isEmpty(response.url)) {
          promise.resolve(response);
        } else {
          promise.reject(response);
        }
      },
    });

    return promise;
  },

  summarize: function (programmerId, text) {
    const promise = $.Deferred();

    $.ajax({
      url: app.apiUrl('/api/v1/summarize'),
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        programmerId: programmerId,
        text: text,
      }),

      error: function () {
        promise.reject();
      },

      success: function (response) {
        if (!_.isEmpty(response.summarizedText)) {
          promise.resolve(response);
        } else {
          promise.reject(response);
        }
      },
    });

    return promise;
  },
});
